let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8CAUL")).then(() => parcelRequire('bmNIT'));